var _ellipse, _rect, _ellipse2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyAppointments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 210 220",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 34.757 45.182 L 62.361 45.182 L 62.361 58.756 C 62.44 61.751 63.601 64.853 65.345 66.8 C 67.088 68.747 69.867 70.042 72.549 70.131 L 72.577 70.131 C 75.259 70.042 78.038 68.747 79.781 66.8 C 81.525 64.853 82.686 61.751 82.766 58.756 L 82.766 45.182 L 132.115 45.182 L 132.115 58.72 C 132.195 61.714 133.356 64.818 135.099 66.765 C 136.842 68.71 139.622 70.006 142.304 70.096 L 142.332 70.096 C 145.014 70.006 147.793 68.71 149.537 66.765 C 151.28 64.818 152.441 61.714 152.521 58.72 L 152.521 45.182 L 175.244 45.182 C 182.848 45.182 189.013 52.065 189.013 60.556 L 189.013 170.894 C 189.013 179.384 182.848 186.268 175.244 186.268 L 34.757 186.268 C 27.153 186.268 20.988 179.384 20.988 170.894 L 20.988 60.556 C 20.988 52.065 27.153 45.182 34.757 45.182 Z M 72.597 33.743 C 75.639 33.743 78.105 37.919 78.105 43.07 L 78.105 54.139 C 78.105 59.29 75.639 63.465 72.597 63.465 C 69.555 63.465 67.09 59.29 67.09 54.139 L 67.09 43.07 C 67.09 37.919 69.555 33.743 72.597 33.743 Z M 142.268 33.732 C 145.31 33.732 147.776 37.908 147.776 43.058 L 147.776 54.127 C 147.776 59.279 145.31 63.454 142.268 63.454 C 139.226 63.454 136.761 59.279 136.761 54.127 L 136.761 43.058 C 136.761 37.908 139.226 33.732 142.268 33.732 Z M 30.727 172.513 L 180.652 172.513 L 180.652 80.997 L 30.727 80.997 L 30.727 172.513 Z",
    stroke: "#000",
    fill: "#000",
    style: {}
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#000",
    fill: "#000",
    cx: 62.01,
    cy: 108.414,
    rx: 12.858,
    ry: 12.858
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86.419,
    y: 100.733,
    width: 72.964,
    height: 14.952,
    stroke: "#000",
    fill: "#000"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#000",
    fill: "#000",
    cx: 62.01,
    cy: 146.391,
    rx: 12.858,
    ry: 12.858
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.419,
    y: 138.71,
    width: 72.964,
    height: 14.952,
    stroke: "#000",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAppointments);
export default __webpack_public_path__ + "static/media/my-appointments.4a9a074f5dd436910468a65bde9c278a.svg";
export { ForwardRef as ReactComponent };